import { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import ModalElement from "../../../Common/ModalElement";
import { appApis, headerColumn } from "../../../constants";
import { useApiRequest } from "../../../hooks/useApiRequest";
import LoadingElement from "../../../Common/LoadingElement";
import ButtonElement from "../../../Common/ButtonElement";
import CourierDetailsModal from "./CourierDetails";
import { PiTruck } from "react-icons/pi";
import { filterListByHeaderState } from "../../../utils";
import { EditableTHead } from "../../../Common/TableElement";

const rowInvValues = ["inventorytype", "gpsimei", "simimei", "simnumber", "transfermode", "currentstate", "instock", "lasttransferdate", "is_new", "tracking_number", "remark"]

const companyRowValues = ["inventorytype", "gpsimei", "simimei", "simnumber", "transfermode", "currentstate", "instock"];

const InventoryDetails = ({ hideModal, show, inventory, showReasonModal, type = "installerId", onSuccess }) => {
    const [data, setData] = useState([]);
    const [modalData, setModalData] = useState(null);
    
    const [list, setList] = useState([]);
    const [state, setState] = useState({});

    const { request, loading } = useApiRequest();
    const { request: transferRequest, loading: transferLoading } = useApiRequest(); 
    
    const isInv = type == "installerId";
    const headers = headerColumn[isInv ? "inventoryDetails" : "companyinventoryDetails"];
    const rowValues = isInv ? rowInvValues : companyRowValues;

    const { filters } = useSelector(({ inventory }) => ({
        filters: inventory.filters
    }), shallowEqual);


    const replaceData = (item) => {
        const transferDetails = filters?.allTransferType?.find(transfer => transfer.name == "Returned to Warehouse") ?? null;
        const warehouseState = filters?.inventoryStates?.find(invState => invState?.name == "Warehouse") ?? null;
        if (transferDetails) {
            const id = item?.inventorytypeid == 21 ? item?.simimei ?? 0 : item?.gpsimei ?? 0;
            const payload = {
                inventory_type_id: item?.inventorytypeid,
                transfer_type_id: transferDetails?.id,
                inventory_state_id: warehouseState?.id,
                recipient_id: filters?.warehouse?.[0]?.id,
                courier_details: null,
                item_ids: [id]
            }
            transferRequest({
                url: appApis.inventoryTransfer,
                method: "POST",
                body: payload,
                onSuccess: () => {
                    hideModal();
                    if (onSuccess) onSuccess();
                }
            })
        }
    }

    const handleInput = (e, index) => {
        let value = e.target.innerText;
        if (!value?.toString().trim().length) {
            e.target.innerText = headers[index];
            e.target.blur();
        }
        setState((prev) => ({ ...prev, [rowValues[index]]: value }));
    };

    useEffect(() => {
        const filtered = filterListByHeaderState(rowValues, data, state);
        setList(filtered);
    }, [state, data]);

    useEffect(() => {
        request({
            url: `${appApis.inventoryDetails}?${type}=${inventory?.installer_id}&inventoryTypeId=${inventory?.inventory_type_id}`,
            showToast: false,
            onSuccess: (responseData) => {
                setData(responseData?.data ?? []);
            }
        })
    }, [])

    return <ModalElement show={show} size="full" title={"Inventory Details"} onHide={hideModal}>
        <div style={{ opacity: modalData ? 0.2 : 1 }}>
            <div className={`card-body`}>
                <div className="table-responsive overflow-auto" style={{ maxHeight: "400px" }}>
                    {loading ? <LoadingElement /> :
                        data?.length > 0 ? <table className="table table-sm table-bordered mb-0" style={{ backgroundColor: "#f9f9f9" }}>
                            <thead className="table-light">
                                <tr>
                                    <th scope="col">Sl No.</th>
                                    {headers.map((item, index) => <EditableTHead isEditable={isInv ? index != 9 && index < 11 : index < headers?.length - 1} item={item} action={(e) => handleInput(e, index)} key={index}/>)}
                                </tr>
                            </thead>
                            <tbody id="inventory-body">
                                {list?.map((item, index) => <tr key={index}>
                                    <td className="text-start">{index + 1}</td>
                                    <td className="text-start">{item?.inventorytype ?? ""}</td>
                                    <td className="text-start">{item?.gpsimei ?? ""}</td>
                                    <td className="text-start">{item?.simimei ?? ""}</td>
                                    <td className="text-start">{item?.simnumber ?? ""}</td>
                                    <td className="text-start">{item?.transfermode ?? ""}</td>
                                    <td className="text-start text-capitalize">{item?.currentstate ?? ""}</td>
                                    <td className="text-start">{item?.instock ?? ""}</td>
                                    {isInv ? <td className="text-start">{item?.lasttransferdate ?? ""}</td> : null}
                                    {isInv ? <td className="text-start">{item?.is_new ? "Yes" : "No"}</td> : null}
                                    <td>
                                        {(item?.courierdetails?.tracking_number || item?.courierdetails?.courier_name) ? <ButtonElement text={<PiTruck size={20} />} cssClass="small-radius small-btn" onClick={() => setModalData(item?.courierdetails ?? null)} variant="btn-black" loading={false} /> : "-"}
                                    </td>
                                    {isInv ? <td className="text-start">{item?.remark ?? ""}</td> : null}
                                    {isInv ? <td className="text-start">
                                        {item?.instock > 0 ? <div className="d-flex justify-content-center">
                                            {!(item?.transfertypeid == 28 || item?.transfertypeid == 27) ? <>
                                                <ButtonElement text="Lost" cssClass="more-radius me-2 py-1" onClick={() => showReasonModal({ ...item, type: "Lost" })} variant="btn-outline-grey" />

                                                <ButtonElement text="Scrap" cssClass="more-radius me-2 py-1" onClick={() => showReasonModal({ ...item, type: "Scrap" })} variant="btn-outline-edit" />
                                            </> : null}

                                            {!item?.is_new ? <ButtonElement loading={transferLoading} text="Warehouse(R)" cssClass="more-radius me-2 py-1" onClick={() => replaceData(item)} variant="btn-outline-preview" /> : null}
                                        </div> : null}

                                    </td> : null}
                                </tr>)}
                            </tbody>
                        </table> : <div className="no-data d-flex justify-content-center align-items-center">
                            <p>No data available</p>
                        </div>}
                </div>
            </div>
        </div>
        {modalData ? <CourierDetailsModal courierDetails={modalData} hideModal={() => setModalData(null)} /> : null}
    </ModalElement>
}

export default InventoryDetails;